export default {
  autocompleteContacts: [],
}